import { createFileRoute } from "@tanstack/react-router";
import { StorePage } from "@/features/portalstore/StorePage";

/** Portal store: active services and packages, with a checkout (P109). */
export const Route = createFileRoute("/portal/store")({
  component: StorePage,
});
